export default __webpack_public_path__ + "static/media/image.apium-innovations-private-limited.3ce22fe0.png";